import { apiV2 } from 'services/axios';
import { BankAccount } from 'models/bankAccounts';
import { AxiosResponse } from 'axios';

export const createPlaidLinkToken = (businessId: string) =>
  apiV2
    .post<unknown, AxiosResponse<{ linkToken: string }>>(
      `/hurdlr/${businessId}/link-token`,
    )
    .then((resp) => resp.data);

export const createHurdlrLinkTokenForUpdate = (
  businessId: string,
  plaidItemId: string,
  enableAccountSelection: boolean = false,
) =>
  apiV2
    .post<{}, AxiosResponse<{ linkToken: string }>>(
      `/hurdlr/${businessId}/link-token/${plaidItemId}`,
      {
        params: {
          enableAccountSelection,
        },
      },
    )
    .then((resp) => resp.data);

export interface ConnectBankAccountParams {
  businessId: string;
  publicToken: string;
  institutionId: string;
  institutionName: string;
}

export const connectBankAccount = (
  params: ConnectBankAccountParams,
): Promise<void> =>
  apiV2.post(`/hurdlr/${params.businessId}/bank-accounts`, {
    plaidPublicToken: params.publicToken,
    institutionId: params.institutionId,
    institutionName: params.institutionName,
  });

export const getBankAccounts = (businessId: string) =>
  apiV2
    .get<BankAccount[]>(`/hurdlr/${businessId}/bank-accounts`)
    .then((resp) => resp.data);

export const removeBankAccount = (businessId: string, plaidItemId: string) =>
  apiV2.delete(`/hurdlr/${businessId}/bank-accounts/${plaidItemId}`);

export const getHurdlrAccessToken = (businessId: string): Promise<string> =>
  apiV2
    .get<{ accessToken: string }>(`/hurdlr/${businessId}/token`)
    .then((resp) => resp.data.accessToken);

export const refreshBankAccounts = (businessId: string): Promise<void> =>
  apiV2.post(`/hurdlr/${businessId}/bank-accounts/refresh`);
